import {Component, OnDestroy, ViewChild} from '@angular/core';
import {SearchUserService} from "../../../@shared/services/search-user.service";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {environment} from "../../../../environments/environment";
import {IUserShort} from "../../../@core/interfaces/user/user.interface";

// export interface IFindUsers {
//   id: number;
//   avatar: string;
//   name: string;
//   dateAdded: string;
//   ip: string;
//   coinsAmount: number;
//   isLocked: boolean;
// }

@Component({
  selector: 'app-find',
  templateUrl: './find.component.html',
  styleUrls: ['./find.component.scss']
})
export class FindComponent implements OnDestroy {
  @ViewChild('paginator', {static: false}) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort!: MatSort;

  public isGoFast: boolean = environment.projectName === 'CSGOFAST';

  private readonly destroyed$: Subject<void> = new Subject();
  public isLoading: boolean = true;

  findUsersColumns: string[] = ['count', 'name', 'dateAdded', 'ip', 'coinsAmount', 'isLocked'];
  findUsersDataSource: MatTableDataSource<IUserShort> = new MatTableDataSource<IUserShort>();

  constructor(private searchUserService: SearchUserService) {
    this.searchUserService.searchResult$
      .pipe(
        takeUntil(this.destroyed$))
      .subscribe((users: IUserShort[]) => {
        this.findUsersDataSource.data = users;
        this.findUsersDataSource.paginator = this.paginator;
        this.findUsersDataSource.sort = this.sort;
      })
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

}
